import styled from 'styled-components';
import colors from 'themes/Main';

const { darkBlue, blue, white, success, successBackground } = colors;

export const AccordionContainer = styled.div`
  position: relative;
  width: auto;
  margin-bottom: 24px;
  min-width: fill-available;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const AccordionHead = styled.label`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  margin-bottom: 0;
  transition: background-color 0.3s ease-in-out;
  background-color: ${({ completed }) => (completed ? success : darkBlue)};
  border-radius: 4px;
  div {
    display: flex;
    align-items: center;
  }

  &:hover {
    background-color: ${({ completed }) =>
      completed ? successBackground : blue};
  }
`;

export const AccordionHeadTitle = styled.p`
  color: ${white};
  transition: color 0.3s ease-in-out;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 0;
`;

export const Counter = styled.small`
  font-size: 14px;
  color: ${white};
  font-weight: 600;
  margin-right: 16px;
`;

export const AccordionHeadIcon = styled.div`
  svg {
    transform: rotate(0deg);
  }
  svg,
  svg path {
    transition: all 0.3s ease-in-out;
  }
`;

export const Checked = styled.input.attrs(({ inputType }) => ({
  type: inputType,
}))`
  display: none;

  &:checked ~ div {
    max-height: 100%;
  }

  &:checked ~ label {
    position: sticky;
    top: 0;
    z-index: 5;
    max-height: 500000px;
  }

  &:checked ~ label div svg {
    transform: rotate(180deg);
  }
`;

export const AccordionContent = styled.div`
  overflow-y: hidden;
  max-height: 0;
  transition: all 0.25s ease-in-out;
`;

export const MoreActionsWrapper = styled.div`
  margin: 4px 16px;

  svg.icon {
    fill: ${white};
    circle {
      fill: ${white};
    }
  }

  .more {
    display: none;
    z-index: 5;
  }
`;
